import React, {Component} from 'react'
import {connect} from 'react-redux'
import * as categories from 'catalog/actions/categories'
import {ListGroup, ListGroupItem} from 'reactstrap'
import SubCategory from 'catalog/components/SubCategory'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import DroppableContext from 'catalog/containers/DroppableContext'
import DnDContext from 'catalog/containers/DnDContext';

@connect(
    state => ({
        subcategoryList: state.categories.subcategoryList,
    }),
    dispatch => ({
        reorderCategoryList: (result, subcategories) => dispatch(categories.reorderCategoryList(result, subcategories))
    })
)
export default class SubCategoryList extends Component {

    @autobind
    changeOrdering(result) {
        this.props.reorderCategoryList(result, this.props.subcategoryList)
    }

    render() {
        const {
            subcategoryList,
        } = this.props;
        return (
            <ListGroup>
                <DnDContext>
                    <DroppableContext droppableId={'subcategory'}>
                        {
                            subcategoryList.map(
                                (category, index) =>
                                    <SubCategory
                                        index={index}
                                        key={`subcategory_${category.id}`}
                                        category={category}
                                    />
                            )

                        }
                    </DroppableContext>
                </DnDContext>
                {
                    subcategoryList.length === 0 &&
                    <ListGroupItem>
                        Keine Unterkategorien vorhanden
                    </ListGroupItem>
                }
            </ListGroup>

        )
    }
}

SubCategoryList.propTypes = {
    subcategoryList: PropTypes.array,
    reorderCategoryList: PropTypes.func
}
